import styled from 'styled-components';

const InvestingExperience = styled.div`
  .row {
    display: flex;
    width: 100%;
    height: auto;
    gap: 30px;
    padding: 30px;
    margin-top: 120px;
    font-size: 0.9rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-top: 90px;
      flex-direction: column-reverse;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        letter-spacing: 0.7px;
        font-weight: 600;
        font-size: 2.5rem;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          text-align: center;
        }
      }

      p {
        font-size: 1.1rem;
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }
    }
  }
`;

export default InvestingExperience;
